import { EmptyState } from '@today/ui-components'
import { Tabs } from '@today/ui-primitives'
import type { ReactElement, ReactNode } from 'react'
import type { Translate } from './org-types'

export type OrgSectionTab = 'units' | 'types'

/**
 * Props for {@link OrgSectionView}.
 *
 * @property mode - `notice` on the platform plane, `forbidden` without any organization read permission, else `tabs`.
 * @property tabs - The readable tabs, in order, with their content.
 */
export interface OrgSectionViewProps {
	t: Translate
	mode: 'notice' | 'forbidden' | 'tabs'
	tabs: Array<{ id: OrgSectionTab; content: ReactNode }>
	activeTab: OrgSectionTab
	onTabChange: (tab: OrgSectionTab) => void
}

/** The console's Organization section shell: platform notice, forbidden state, or the Units/Types tabs (organism). */
export function OrgSectionView(props: OrgSectionViewProps): ReactElement {
	const { t } = props
	if (props.mode === 'notice') return <EmptyState title={t('section.platformNotice')} />
	if (props.mode === 'forbidden') return <EmptyState title={t('section.forbidden')} />
	return (
		<Tabs
			tabs={props.tabs.map((tab) => ({ id: tab.id, label: t(`section.tabs.${tab.id}`), content: tab.content }))}
			selectedKey={props.activeTab}
			onSelectionChange={(key) => props.onTabChange(String(key) as OrgSectionTab)}
		/>
	)
}
